//
//
//
//
//
//
//
//
//
//
//
//
//

import RichText from './RichText'

export default {
  components: {
    RichText
  },
  props: [
    'content'
  ],
  mounted() {
        setTimeout(function() {
            let textPage = document.querySelectorAll('.page-text')
            
            if (textPage.length > 0) {
                textPage.forEach(item => {
                    let p = item.getElementsByTagName('h3');
                    console.log(p)
                    if (p.length > 0) {
                        p.forEach(elem => {
                            if (elem.innerText == 'Perkins Restaurants Messaging Terms') {
                                elem.id = 'sms-terms'
                                console.log(elem)
                            }
                        })
                    }
                })
            }
            if(window.location.hash) {
                const element = document.getElementById(window.location.hash.split('#')[1]);
                if (element != undefined || element != null) {
                    element.scrollIntoView({ behavior: "smooth"});
                }
            } 
        }, 50)
    },
}
